import PropTypes      from 'prop-types';
import UICircleButton from 'components/UI/CircleButton';
import cns            from 'classnames';
import styles         from './view-hoc-action.module.scss';

import DefaultIcon    from '@material-ui/icons/FiberManualRecord';

const ViewAction = ({ 
  icon = <DefaultIcon/>,
  label,
  title = '',
  positive = false,
  negative = false,
  inverted = false,
  href,
  onClick = () => {}
}) => {
  return (
    <div
      className={cns(styles.root, {
        [styles.with_label]: !!label
      })}
      onClick={onClick}
    >
      <UICircleButton
        icon={icon}
        href={href}
        title={title}
        positive={positive}
        negative={negative}
        inverted={inverted}
      />

      <If condition={label}>
        <div className={styles.label}>
          {label}
        </div>
      </If>
    </div>
  )
};

ViewAction.propTypes = {
  icon:     PropTypes.element,
  label:    PropTypes.string,
  title:    PropTypes.string,
  positive: PropTypes.bool,
  negative: PropTypes.bool,
  inverted: PropTypes.bool,
  href:     PropTypes.string,
  onClick:  PropTypes.func,
};

export default ViewAction;